<template>
     <el-dialog title="复制活动" :visible.sync="copyDialogVisible" class="copy-popu" width="600px" :before-close="clear">
            <div class="content">
                
                <div class="head">
                    <p style="margin-right: 30px;">复制活动到</p>
                    <el-radio-group v-model='radio' @change='tabTable'>
                        <el-radio label='1' >单个社群</el-radio>
                        <el-radio label='2'>社群分组</el-radio>
                    </el-radio-group>
                    
                </div>

                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="名称">
                        <template slot-scope='scope'>
                            {{ scope.row.name}}
                            <!-- <p v-if="radio == '1'">
                                {{ scope.row.name}}
                            </p>
                            <p v-if="radio == '2'">
                                {{ scope.row.groupname}}
                            </p> -->
                        </template>
                    </el-table-column>
                </el-table>

                
                <el-pagination background layout="prev, pager, next" :total="totalPage" @current-change="fPage" :current-page.sync="apidata.page"></el-pagination>

                 <span slot="footer" class="dialog-footer">
                    <el-button @click="clear">取 消</el-button>
                    <el-button type="primary" @click="submit">确 定</el-button>
                </span>

            </div>
        </el-dialog>
    <!-- end 复制活动 -->
</template>

<script>
import fecha from 'element-ui/src/utils/date'
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery'
import {getCommGroupList, getAssociationsList} from 'api/cPurchaseApi'
    export default {
        name: "CopyActive",
        props: ['copyDialogVisible'],
        data() {
            return {
                radio: '1', // 单选数据
                tableData: [],  // 表单数据
                multipleSelection: [], // 选中数据
                totalPage: 0,
                apidata: {
                    page: 1,
                    pageSize: 10
                }
            }
        },
        mounted() {
            this.tabTable()
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            fPage() {    // 分页
                let clickPage = $(".copy-popu .el-pagination .active").html()
                console.log('fPage',clickPage)
                if (this.radio == "1") {
                    this.sqApi(clickPage)
                } else if (this.radio == "2") {
                    this.fzApi(clickPage)
                }
            },
            sqApi(page) {  // 单个社群
                // console.log('接口测试单个社群')
                console.log('sqApi',page)

                this.setLoading(true)
                this.apidata.page = page
                this.apidata.status = 1

                getAssociationsList({
                    data: this.apidata,
                    success: data => {
                        this.setLoading(false)
                        this.tableData = data.data.content
                        this.totalPage = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            fzApi (page) {  // 社群分组
                // console.log('接口测试社群分组')
                this.setLoading(true)
                getCommGroupList({
                    data: this.apidata,
                    success: data => {
                        this.setLoading(false)
                        this.tableData = data.data.content
                        this.totalPage = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            tabTable() {  
                //  console.log('接口测试类别判断')
                if (this.radio == "1") {
                    this.apidata.page = 1
                    this.sqApi(1)
                } else if (this.radio == "2") {
                    this.apidata.page = 1
                    this.fzApi(1)
                }
            },
            clear() {
                this.$emit('statusdialog',false)
            },
            submit() {
                if (this.multipleSelection.length < 0) {
                    this.$message.info('请选择需要复制的单个社群/社群分组')
                } else {
                    console.log(this.multipleSelection)
                    let arrinnerid = ''
                    for (let i = 0; i < this.multipleSelection.length; i++) {

                        if (i ==  this.multipleSelection.length - 1) {
                            arrinnerid += this.multipleSelection[i].innerid
                        } else {
                            arrinnerid += this.multipleSelection[i].innerid + ','
                        }
                       
                    }

                    if (this.radio == "1") {
                        this.$emit('copydata', {name: 'assinnerid', content: arrinnerid})
                    } else if (this.radio == "2") {
                         this.$emit('copydata', {name: 'groupinnerid', content: arrinnerid})
                    }
                    this.clear()
                }
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style type="scss" lang="scss" type="text/scss">
    .copy-popu {
        .dialog-footer {
            display: block;
            margin-top: 30px;
            text-align: center;
        }
        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }
    }
</style>